import Table from './Table';

export default Table;



// WEBPACK FOOTER //
// ./src/table/index.js